<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.lesson_name" placeholder="输入课程名称" @on-search="handleSearch" style="width:100%;" />
                </Col>
               
                <Col span="2" style='float:right'>
                    <i-button icon="md-add" shape="circle" type="primary" @click="add_new">添加</i-button>
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row style='margin-bottom: 20px;'>
                <Col span="10">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span="6">
                    <Select v-model="formItem.type_id" placeholder="课程类型" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in typeList" :value="item.type_id" :key="item.type_id">{{ item.name }}</Option>
                    </Select>
                </Col>
                <Col span="4">
                    <Select v-model="formItem.status" placeholder="状态" @on-change="handleSearch"  clearable style="width:160px">
                        <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
        <Modal v-model="addModel" width="800" title="新增">
            <div v-if='addModel'>
                <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">
                    <Row>
                        <Col span="11">
                          <FormItem label="课程名称" prop='name'>
                              <Input v-model="formData.name" placeholder="请输入..."></Input>
                          </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                          <FormItem label="副标题" prop='desc'>
                              <Input v-model="formData.desc" placeholder="请输入..."></Input>
                          </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="20">
                            <FormItem label="课程类型" prop='type_id'>
                                <Select v-model="formData.type_id" placeholder="请选择"  clearable style="width:200px">
                                    <Option v-for="item in typeList" :value="item.type_id" :key="item.type_id">{{ item.name }}</Option>
                                </Select> 
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="20">
                            <FormItem label="目录类型" prop='directory_type'>
                                <Radio-group v-model="formData.directory_type">
                                    <Radio label="1">星球长图</Radio>
                                    <Radio label="2">星球短图</Radio>
                                    <Radio label="3">羊皮纸长图</Radio>
                                    <Radio label="4">羊皮纸短图</Radio>
                                    <Radio label="7">乐宝</Radio>
                                    <Radio label="8">环球之旅(横)</Radio>
                                </Radio-group>
                            </FormItem>
                        </Col>
                    </Row>
                    <FormItem label="封面">
                        <UploadImg @getPicList="getPicList" v-if='addModel' :getList='formData.cover_url' message='1' id='cover'></UploadImg>
                    </FormItem>
                    <FormItem label="视频简介">
                        <UploadVideo @getVideos="getVideo" v-if='addModel' :getVideourl='formData.video_url' message='1' id='cover'></UploadVideo>
                    </FormItem>
                    <FormItem label="课程详情" v-if='addModel'>
                        <UE :defaultMsg="defaultMsg" :config="config" ref="ue"></UE>
                    </FormItem>

                </Form>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle"  ghost @click='cancel'>取消</Button>
                <Button type="primary" shape="circle"  @click="save('formData')">确定</Button>
            </div>
        </Modal>
        <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
       
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        fetchInfo,
        addSave,
        modifySave,
        setStatus,
    } from '@/api/courseMassage'
    import {
        fetchLessonTypeList,
    } from '@/api/common'

    import UploadImg from '../common/picture.vue'
    import UploadVideo from '../common/videos.vue'
    import UE from '../common/ueditor.vue'



    export default {
        name: 'user-components',
        components: {
            UploadImg,
            UploadVideo,
            UE
        },
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    type_id: '', 
                    lesson_name: '', 
                    start_time:'',
                    end_time:'',
                    status:'',
                },
                start_time:'',
                end_time:'',
                typeList:[],
                lesson_id:'',
                statusList:[
                    {id:1,name:'上架'},
                    {id:0,name:'下架'},
                ],
                defaultMsg: '',
                config: {
                    initialFrameWidth: null,
                    initialFrameHeight: 350
                },
                addModel:false,//添加修改弹出层状态
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                formData:{
                    lesson_id:'',
                    name:'',
                    desc:'',
                    type_id:'',
                    cover_url:'',
                    video_url:'',
                    lesson_info:'',
                    directory_type:'',
                },//添加修改的表单数据
                verificationRule:{
                    nickname: [
                        { required: true, message: '昵称不能为空'}
                    ],
                },//添加修改的表单验证规则
              
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '课程名称',
                        align: 'center',
                        key: 'name',

                    },
                    {
                        title: '课程类型',
                        align: 'center',
                        key: 'type_name',
                    },
                    {
                        title: '课程节数',
                        align: 'center',
                        key: 'lesson_count',
                        
                    },
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('span','上架' )
                            }else{
                                return h('span','下架' )
                            }
                        }                        
                    },
                   
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width: 150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 160,
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.lesson_id)
                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.lesson_id,'确定下架该课程吗？')
                                            }
                                        }
                                    }, '下架'),
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.lesson_id)
                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.lesson_id,'确定上架该课程吗？')
                                            }
                                        }
                                    }, '上架'),
                                ])
                            }
                            
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            getLessonTypeList(){
                fetchLessonTypeList().then(res => {
                    res=res.data;
                    if(res.code == 200){
                        this.typeList = res.data;
                       
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 添加
            add_new(){
                this.formData.lesson_id='';
                this.formData.name='';
                this.formData.desc='';
                this.formData.type_id='';
                this.formData.cover_url='';
                this.formData.video_url='';
                this.formData.lesson_info='';
                this.formData.directory_type='';

                this.defaultMsg = '';
                this.addModel=true;
            },
            // 修改获取详情
            edit(id){
                fetchInfo({
                    lesson_id:id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.formData=res.data;
                        this.formData.lesson_id=id;

                        this.defaultMsg = res.data.lesson_info;

                        this.addModel=true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            // 保存新增和修改
            save(name){
                this.$refs[name].validate(valid => {
                    if (valid) {
                        this.formData.lesson_info=this.$refs.ue.getUEContent();
                        if(this.formData.lesson_id!=''){
                            modifySave(this.formData).then(res => {
                                res = res.data;
                                if (res.code == 200) {
                                    this.getData();
                                    this.addModel=false;
                                } else if (res.code == 14001) {
                                this.$Message.error(res.msg)
                                this.$store.dispatch('handleLogOut').then(res => {
                                    this.$store.commit('clearOpenedSubmenu')
                                    this.$router.push({
                                    name: 'login'
                                    })
                                })
                                } else {
                                this.$Message.error(res.msg)
                                }
                            })
                        }else{
                            addSave(this.formData).then(res => {
                                res = res.data;
                                if (res.code == 200) {
                                    this.getData();
                                    this.addModel=false;
                                } else if (res.code == 14001) {
                                this.$Message.error(res.msg)
                                this.$store.dispatch('handleLogOut').then(res => {
                                    this.$store.commit('clearOpenedSubmenu')
                                    this.$router.push({
                                    name: 'login'
                                    })
                                })
                                } else {
                                this.$Message.error(res.msg)
                                }
                            })
                        }
                        
                    
                    }
                })
            },

            // 改变状态
            changeStatus(id,info) {
                this.lesson_id = id;
                this.remindContent = info;
                this.remindModal = true; 
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                setStatus({
                    lesson_id:this.lesson_id
                }).then(res => {
                    res=res.data;
                    if(res.code==200){
                        this.getData();
                        this.remindModal=false;
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            getPicList(picList) {
                this.formData.cover_url = picList[0].url.split('.com')[1]
            },
            getVideo(list){
                this.formData.video_url = list[0].url.split('.com')[1]
            },
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            changEndtime(time) {
    
                if (time == '') {
                    this.formItem.end_time = '';
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.schoolModel=false;
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
            this.getLessonTypeList();
        }
    };
</script>
